export default __webpack_public_path__ + "static/media/bg_layer2.2ed2b379.svg";